import type { PaletteKey } from './colors';

// Asset display states (UI design doc §2). Five mirror the Postgres `presence_state` enum; `untagged`
// and `awaiting_receipt` are derived (no active electronic tag / open transfer line awaiting receipt).
// Every chip carries text, never colour alone.
export const ASSET_DISPLAY_STATES = [
  'on_site',
  'in_transit',
  'off_site',
  'missing',
  'unknown',
  'untagged',
  'awaiting_receipt',
] as const;

export type AssetDisplayState = (typeof ASSET_DISPLAY_STATES)[number];

export interface StateChipToken {
  /** Text colour and border. */
  readonly fg: PaletteKey;
  /** Chip background. */
  readonly bg: PaletteKey;
  /** Locale key for the chip label, resolved from `src/i18n/<lang>.json`. */
  readonly labelKey: `state.${AssetDisplayState}`;
}

export const stateChips = {
  on_site: { fg: 'ok', bg: 'okSoft', labelKey: 'state.on_site' },
  in_transit: { fg: 'warn', bg: 'warnSoft', labelKey: 'state.in_transit' },
  off_site: { fg: 'warn', bg: 'warnSoft', labelKey: 'state.off_site' },
  missing: { fg: 'bad', bg: 'badSoft', labelKey: 'state.missing' },
  unknown: { fg: 'neutral', bg: 'neutralSoft', labelKey: 'state.unknown' },
  untagged: { fg: 'steel', bg: 'steelSoft', labelKey: 'state.untagged' },
  awaiting_receipt: { fg: 'accentInk', bg: 'accentSoft', labelKey: 'state.awaiting_receipt' },
} as const satisfies Record<AssetDisplayState, StateChipToken>;
